export default __webpack_public_path__ + "static/media/5.9274dbc2.jpg";